import { render } from "./DelayElement.vue?vue&type=template&id=6e9cd4fa&scoped=true"
import script from "./DelayElement.vue?vue&type=script&lang=js"
export * from "./DelayElement.vue?vue&type=script&lang=js"

import "./DelayElement.vue?vue&type=style&index=0&id=6e9cd4fa&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9cd4fa"]])

export default __exports__